export enum BettingRulesQueryKeys {
  BettingRules = "bettingRules",
  UserBettingRules = "userBettingRules",
}
